// @flow
import * as React from 'react'
import Linkify from 'linkify-react'

import styles from './linkify.module.scss'

interface Props {
  children: React.ReactNode
  className?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: any
}

const defaultOptions = {
  attributes: {
    rel: 'nofollow noindex',
  },
  nl2br: true,
}

const LinkifyContainer = ({ children, className = '', options = {}}: Props) => (
  <Linkify
    className={`${styles.linkify} ${className}`}
    tagName="p"
    options={{ ...defaultOptions, ...options }}
  >
    {children}
  </Linkify>
)

export default LinkifyContainer
